export default __webpack_public_path__ + "static/media/chevron-down-invite.947e2abc.svg";